// One-shot "?af=pdf" deep-link flag. Marketing links append af=pdf to any
// landing URL to put the whole funnel in digital-only mode: the create flow
// pre-selects the digital (PDF) variant and never shows the physical book
// options. Captured once at page load into sessionStorage — so the flag
// survives in-tab navigation (home → category → create) but not a new visit —
// and immediately stripped from the address bar so the param disappears and is
// never carried along or re-shared.
const KEY = 'anabatal_af';

export function captureAfParam() {
  const params = new URLSearchParams(window.location.search);
  const af = params.get('af');
  if (!af) return;
  try {
    sessionStorage.setItem(KEY, af);
  } catch {
    // Storage unavailable (private mode / quota) — leave the param in the URL;
    // getAfMode falls back to reading it directly, so at least the landing
    // page still honours the link.
    return;
  }
  params.delete('af');
  const qs = params.toString();
  // Preserve history.state — react-router keeps its location state in there.
  window.history.replaceState(
    window.history.state,
    '',
    window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash,
  );
}

export function getAfMode() {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v) return v;
  } catch { /* fall through to the URL */ }
  return new URLSearchParams(window.location.search).get('af');
}
